module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"reset_title":"Passwort zurücksetzen","reset_hint":"Nach dem Absenden erhalten Sie eine Email zum Zurücksetzen ihres Passwortes.","reset_submit":"Passwort zurücksetzen"},"en":{"reset_title":"Reset password","reset_hint":"An email to reset your password will be sent to your email address.","reset_submit":"Reset password"}}')
  delete Component.options._Ctor
}
